<section *ngIf="processing">
  <h2>{{processingMessage}}...</h2>
  <mat-progress-bar mode="indeterminate" color="warn" aria-label="processing...">
  </mat-progress-bar>
</section>

<section *ngIf="!processing">
  <!-- Action Buttons -->
  <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
    <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
      <h2 class="noMarginHeader"><mat-icon>note_add</mat-icon> Generate {{letter.letterType}} Letter - {{voucher.voucherId}}</h2>
    </div>
    <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
      <button type="submit" name="SubmitButton" (click)="onSubmitKendo()" mat-raised-button color="primary" value="Save" title="Save">Save</button>
      &nbsp;&nbsp;
      <button mat-button mat-dialog-close="Cancel" mat-raised-button color="basic" aria-label="Cancel">Cancel</button>
    </div>
  </div>
  <hr />
</section>

<mat-dialog-content id="voucherLetterPdf">
  <div class="print-outer" >
    <div class="print-inner">
      <kendo-pdf-export #pdf paperSize="letter" paperSize="A4" margin="2cm" [scale]="0.4" forcePageBreak=".page-break">
        <ng-container [ngTemplateOutlet]="kendoTemplate"
                      [ngTemplateOutletContext]="{export: true}">
                    </ng-container>
      </kendo-pdf-export>
      </div>
  </div>
  <ng-template #kendoTemplate let-export="export">
    <style>
      .english-text  {
          font-family:  'SpanishLatin',  'SpanishLatinBold'  ;
          font-size: 20pt;
      }
      kendo-pdf-export {
      font-family:  'SpanishLatin',  'SpanishLatinBold'  ;
      font-size: 20pt;
        }
    </style>
  <!-- English -->
  <section>
    <Header>
      <img src="{{environment.baseUrl}}/assets/images/OregonWell_Letterheader.png" alt="Letter Header" width="100%">
    </Header>
    <style>
      td,
      th {
        border: 1px solid #dddddd;
        margin-left: 5.4pt;
        padding: 0in 5.4pt 0in 5.4pt
      }
    </style>

    <body class="english-text">
      <p >
        {{today | date: 'MMMM d, y':'':'' }}
      </p>
      <p style='color:green; '>
        {{voucher?.applicantContactName}}<br>
        {{voucher?.applicantAddress}}<br>
        {{voucher?.applicantCity}} {{voucher?.applicantState}} {{voucher?.applicantZip}}</p>
      <p></p>
      <p></p>
      <p >Dear <span style='color:green; '>{{voucher?.applicantContactName}}:</span></p>

      <span *ngIf="letter.letterType == voucherService.voucherSelfSampleLetterType">
        <!-- English Self Sample version-->
        <p >
          Thank you for requesting free testing of your domestic well water. The groundwater in parts of northern Morrow and northwestern Umatilla Counties,
          including areas near your household, is contaminated with nitrate at levels that can harm health. You can become exposed to nitrate when you use
          contaminated well water for drinking and cooking. Babies fed with formula and pregnant women may suffer harm even from short exposures,
          and everyone may experience harm from long-term exposure. The enclosed fact sheet provides more information about nitrate exposure and health.
        </p>

        <p >
          This letter includes a voucher (or coupon) number that you can use to get your well water tested at a local water testing lab, free of charge.
          <strong>Your voucher number is: {{voucher.voucherId}}</strong>
        </p>

        <p >
          This voucher (or coupon) also covers one-time testing for several contaminants in addition to nitrate at no cost to you: arsenic, total coliform,
          E. coli, lead, iron, manganese and hardness.
        </p>

        <p >
          To collect a water sample, you'll need to visit one of the locations on the included Nitrate Test Kit Pick-Up and Drop-Off Sites list to pick up a sample kit and/or to drop off your
          completed sample.
          Please bring the included Chain of Custody form when you drop off your sample to ensure your sample is properly processed.
        </p>

       
        <p >
          The lab will send you the results of your test, and OHA will send a letter with additional information about your results. If you change your mind and
          would like assistance with collecting the water sample and getting it to the laboratory, please call our team at 541-952-9254 or email us at Domestic.Wells@odhsoha.oregon.gov.
        </p>

        <p >
          Thank you for taking the time to request well testing. Getting your well tested is important to protecting the health of your family, pets, and the people in your community.
          Households served by wells with high nitrate levels will receive free water deliveries and/or installation of a water treatment system, depending on test results.
        </p>

        <p >
          Sincerely,<br />
          Oregon Health Authority<br />
          Domestic Well Safety Program <br />
          800 NE Oregon St Ste 640, Portland OR 97232 | 541-952-9254<br /> 
          https://testmywell.oregon.gov | https://pruebadepozo.oregon.gov
          
      
        </p>
        <br />
        <br />
        <!-- footer table -->
        <span style="page-break-before: always;"></span>
        <table style="width:100%; border: 0px;">
          <tr style="border: 0px;">
            <td colspan="4" style="width:100%; border: 0px;">
              <p >
                <strong>Contact information for your county public health departments:</strong>
              </p>
            </td>
          </tr>
          <tr style="border: 0px;">
            <td style="width:25%; border: 0px;">
              Morrow County Public Health <br />
              (541) 256-0514 <br />
              mchealth@morrowcountyor.gov<br />
            </td>
            <td style="width:25%; border: 0px;">
              <img src="{{environment.baseUrl}}/assets/images/morrow.png" alt="Morrow County Log">
            </td>
            <td style="width:25%; border: 0px;">
              Umatilla County Public Health <br />
              (541) 278-6394<br />
              health@umatillacounty.gov<br />
            </td>
            <td style="width:25%; border: 0px;">
              <img src="{{environment.baseUrl}}/assets/images/umatilla.jpg" alt="Umatilla County Logo">
            </td>
          </tr>
          <tr>
            <td colspan="4" style="width:100%; border: 0px;">
              <p >
                <strong>Contact information for some local community-based organizations that support this work:</strong>
              </p>
            </td>
          </tr>
          <tr>
            <td style="width:25%; border: 0px;">
              Doulas Latinas International 
              Phone /Text: 971-381-4895<br />

            </td>
            <td style="width:25%; border: 0px;">
              <img src="{{environment.baseUrl}}/assets/images/DLI-logo.png" alt="DLI Logo" width="50%" height="50%">
            </td>
            <td style="width:25%; border: 0px;">
              Eastern Oregon Center for Independent Living (EOCIL) <br />
              (541) 889-3119 <br />
            </td>
            <td style="width:25%; border: 0px;">
              <img src="{{environment.baseUrl}}/assets/images/EOCIL-logo.png" alt="EOCIL Logo" width="50%" height="50%">
            </td>
          </tr>
          <tr>
            <td style="width:25%;   border: 0px;">
              Euvalcree <br />
              541-567-1185<br />


            </td>
            <td style="width:25%; border: 0px;">
              <img src="{{environment.baseUrl}}/assets/images/Euvalcree.png" alt="Euvalcree Logo" width="50%" height="50%">
            </td>
            <td style="width:25%; border: 0px;">
              H2OEO - Water for <br />
              Eastern Oregon<br />
              info@h20eo.org<br />

            </td>
            <td style="width:25%; border: 0px;">
              <img src="{{environment.baseUrl}}/assets/images/H2OEO-logo.jpg" alt="H2OEO Logo" width="50%" height="50%">
            </td>
          </tr>
          <tr>
            <td style="width:25%; border: 0px;">
              Northwest Center for Alternatives to Pesticides<br />
              Info@pesticide.org <br />
              Phone /Text: (509) 727-9361<br />



            </td>
            <td style="width:25%; border: 0px;">
              <img src="{{environment.baseUrl}}/assets/images/NCAP-logo.png" alt="NCAP Logo" width="50%" height="50%">
            </td>
            <td style="width:25%; border: 0px;">
              Oregon Rural Action<br />
              (541) 975-2411<br />
              info@oregonrural.org<br />


            </td>
            <td style="width:25%; border: 0px;">
              <img src="{{environment.baseUrl}}/assets/images/ORA-logo.jpg" alt="ORA Logo" width="50%" height="50%">
            </td>
          </tr>
        </table>
        <br />
      </span>
      <span *ngIf="letter.letterType == voucherService.voucherScheduleLetterType">
        <!-- English Schedule version-->
        <p >
          Thank you for requesting free testing of your domestic well water for the well located at
          {{voucher?.well?.address1}}, {{voucher?.well?.city}}, OR {{voucher?.well?.zip}}.
          The groundwater in parts of northern Morrow and Umatilla Counties,
          including areas near your household, is contaminated with nitrate at levels that can harm health. You can become exposed to nitrate when
          you use contaminated well water for drinking and cooking. Bottle-fed babies and pregnant women may suffer harm even from short exposures,
          and everyone may experience harm from long-term exposure. The enclosed fact sheet provides more information about nitrate exposure and health.
        </p>
        <p >
          Your test will cover nitrate and also one-time testing for several other contaminants at no cost to you: arsenic, total coliform,
          E. coli, lead, iron, manganese and hardness.
        </p>
        <p >
          A staff person will contact you to schedule an appointment to collect a water sample and take it to the laboratory for analysis.
        </p>
        <p >
          The lab will send you the results of your test, and OHA will send a letter with additional information about your results.
        </p>
        <p >
          Thank you for taking the time to request well testing. Getting your well tested is important to protecting the health of your family, pets,
          and the people in your community. Households served by wells with high nitrate levels will receive free water deliveries and/or installation of a
          water treatment system, depending on test results.
        </p>
        <p >
          Depending on the number of people requesting assistance, it may take a few days for our scheduler to contact you.
          If have not received a call within five business days, or if you have any other questions, please call our team at 541-952-9254 or
          email us at Domestic.Wells@odhsoha.oregon.gov.
        </p>
        <p >
          Sincerely,<br />
          Oregon Health Authority<br />
          Domestic Well Safety Program<br />
          800 NE Oregon St Ste 640, Portland OR 97232 | 541-952-9254<br />https://testmywell.oregon.gov | https://pruebadepozo.oregon.gov
      
        </p>
      </span>
    </body>
  </section>
  <br /><br />
  <span style="page-break-before: always;">

  </span>
  <!-- Spanish -->
        <span class="page-break"></span>
  <section>
    <Header>
      <img src="{{environment.baseUrl}}/assets/images/OregonWell_Letterheader.png" alt="Letter Header" width="100%">
    </Header>
    <style>
      td,
      th {
        border: 1px solid #dddddd;
        margin-left: 5.4pt;
        padding: 0in 5.4pt 0in 5.4pt
      }
    </style>

    <body class="spanish-text">
      <p >
        {{today | date: 'd MMMM, y':'':'es' }}
      </p>
      <p style='color:green; '>
        {{voucher?.applicantContactName}}<br>
        {{voucher?.applicantAddress}}<br>
        {{voucher?.applicantCity}} {{voucher?.applicantState}} {{voucher?.applicantZip}}</p>
      <p></p>
      <p></p>

      <p >Estimado/Estimada <span style='color:green; '>{{voucher?.applicantContactName}}:</span></p>


      <span *ngIf="letter.letterType == voucherService.voucherSelfSampleLetterType">
        <!-- Spanish Self Sample version-->
        <p >

          Gracias por solicitar la prueba gratis del agua de su pozo doméstico. El agua subterránea en partes del norte del Condado de Morrow y el noroeste del Condado
          de Umatilla, incluyendo áreas cerca de su hogar, está contaminada con nitrato en nivelas que pueden causar daños a la salud. Puede quedar expuesto al nitrato
          cuando usa agua de pozo contaminada para beber y cocinar. Los bebés alimentados con leche de formula y las mujeres embarazadas pueden sufrir daños incluso si
          están expuestos durante poco tiempo, y todos pueden sufrir daños por exposiciones a largo plazo. En la hoja informativa adjunta encontrará más información sobre
          la exposición al nitrato y la salud.
        </p>

        <p >
          Esta carta incluye un número de vale (o cupón) que puede usar para analizar el agua de su pozo en un laboratorio local de análisis de agua, sin cargo.
          <strong class="spanish-text-bold">Su número de comprobante es: {{voucher.voucherId}}</strong>
        </p>

        <p >
          Además de cubrir el costo del análisis de nitrato, cubriremos el costo una vez para analizar los siguientes contaminantes: arsénico, coliformes totales,
          E. coli, plomo, hierro, manganeso y dureza.
        </p>

        <p >
          Para recolectar una muestra de agua, deberá visitar una de las ubicaciones en la lista incluida de sitios de recogida y entrega de kits de prueba de
          nitrato para recoger un kit de muestra y/o dejar su muestra completa. El kit incluye un formulario de Cadena de Custodia (“Chain of Custody Form”).
          Por favor tráigalo con usted cuando pase dejando su muestra para asegurar que su muestra se procese correctamente.
        </p>

        <p >
          El laboratorio le enviará los resultados de su prueba, y la OHA le enviará una carta adicional con información adicional sobre sus resultados.
          Si cambia de opinión y necesita ayuda para recolectar la muestra y llevarla al laboratorio,
          llame a nuestro equipo al 541-952-9254 o envíenos un correo electrónico a Domestic.Wells@odhsoha.oregon.gov.
        </p>

        <p >
          Gracias por tomarse el tiempo de solicitar la prueba para su pozo. Es importante analizar su pozo para proteger la salud de su familia, sus mascotas y
          las personas en su comunidad. Los hogares que usen pozos con niveles altos de nitrato recibirán entregas gratuitas de agua y/o la instalación gratuita de
          un sistema de tratamiento de agua, según los resultados de la prueba

        </p>

        <p >
          Atentamente,<br />
          Oregon Health Authority<br />
          Domestic Well Safety Program - Programa de Seguridad de Pozos Domésticos<br />
          800 NE Oregon St Ste 640, Portland OR 97232 | 541-952-9254<br />https://testmywell.oregon.gov | https://pruebadepozo.oregon.gov
      
        </p>

        <!-- footer table -->
        <table style="width:100%; border: 0px;">
          <tr style="border: 0px;">
            <td colspan="4" style="width:100%; border: 0px">
              <p >
                <span>Información de contacto de los departamentos de salud pública de su condado:</span>
              </p>
            </td>
          </tr>
          <tr style="border: 0px;">
            <td style="width:25%; border: 0px">
              Departamento de Salud Pública del Condado de Morrow <br />
              (541) 256-0514 <br />
              mchealth@morrowcountyor.gov<br />
            </td>
            <td style="width:25%; border: 0px">
              <img src="{{environment.baseUrl}}/assets/images/morrow.png" alt="Morrow County Log">
            </td>
            <td style="width:25%; border: 0px">
              Departamento de Salud Pública del Condado de Umatilla <br />
              (541) 278-6394<br />
              health@umatillacounty.gov<br />
            </td>
            <td style="width:25%; border: 0px">
              <img src="{{environment.baseUrl}}/assets/images/umatilla.jpg" alt="Umatilla County Logo">
            </td>
          </tr>
          <tr style="border: 0px;">
            <td colspan="4" style="width:100%; border: 0px">
              <p>&nbsp;</p>
              <p >
                <span>Información de contacto de algunas organizaciones comunitarias locales que apoyan este trabajo:</span>
              </p>
            </td>
          </tr>
          <tr style="border: 0px;">
            <td style="width:25%; border: 0px">
              Doulas Latinas International  <br />
              Teléfono/Texto: 971-381-4895<br />

            </td>
            <td style="width:25%; border: 0px">
              <img src="{{environment.baseUrl}}/assets/images/DLI-logo.png" alt="DLI Logo" width="50%" height="50%">
            </td>
            <td style="width:25%; border: 0px">
              Eastern Oregon Center for Independent Living (EOCIL) <br />
              (541) 889-3119 <br />
            </td>
            <td style="width:25%; border: 0px">
              <img src="{{environment.baseUrl}}/assets/images/EOCIL-logo.png" alt="EOCIL Logo" width="50%" height="50%">
            </td>
          </tr>
          <tr style="border: 0px;">
            <td style="width:25%; border: 0px">
              Euvalcree <br />
              541-567-1185<br />


            </td>
            <td style="width:25%; border: 0px">
              <img src="{{environment.baseUrl}}/assets/images/Euvalcree.png" alt="Euvalcree Logo" width="50%" height="50%">
            </td>
            <td style="width:25%; border: 0px">
              H2OEO - Water for <br />
              Eastern Oregon<br />
              info@h20eo.org<br />

            </td>
            <td style="width:25%; border: 0px">
              <img src="{{environment.baseUrl}}/assets/images/H2OEO-logo.jpg" alt="H2OEO Logo" width="50%" height="50%">
            </td>
          </tr>
          <tr style="border: 0px;">
            <td style="width:25%; border: 0px">
              Northwest Center for Alternatives to Pesticides<br />
              Info@pesticide.org <br />
              Teléfono/Texto: (509) 727-9361<br />



            </td>
            <td style="width:25%; border: 0px">
              <img src="{{environment.baseUrl}}/assets/images/NCAP-logo.png" alt="NCAP Logo" width="50%" height="50%">
            </td>
            <td style="width:25%; border: 0px">
              Oregon Rural Action<br />
              (541) 975-2411<br />
              info@oregonrural.org<br />


            </td>
            <td style="width:25%; border: 0px">
              <img src="{{environment.baseUrl}}/assets/images/ORA-logo.jpg" alt="ORA Logo" width="50%" height="50%">
            </td>
          </tr>
        </table>
        <br />

      </span>
      <span *ngIf="letter.letterType == voucherService.voucherScheduleLetterType">
        <!-- Spanish Schedule version-->
        <p >
          Gracias por solicitar una prueba gratuita de su agua de pozo doméstico para el pozo ubicado en
          {{voucher?.well?.address1}}, {{voucher?.well?.city}}, {{voucher?.well?.state}} {{voucher?.well?.zip}}. El agua subterránea en partes norteñas de los condados de Morrow y Umatilla está
          contaminada con nitrato a niveles que pueden dañar la salud. Las personas pueden quedar expuestas al nitrato cuando usan agua de pozo contaminada para beber
          y cocinar. Los bebés alimentados con biberón y las mujeres embarazadas pueden sufrir daños incluso con exposiciones breves, y todos pueden experimentar
          daños con la exposición a largo plazo. La hoja informativa adjunta brinda más información sobre la exposición al nitrato y la salud.
        </p>

        <p >
          Además de cubrir el costo del análisis de nitrato, cubriremos el costo una vez para analizar los siguientes contaminantes: arsénico, coliformes totales,
          E. coli, plomo, hierro, manganeso y dureza.
        </p>

        <p >
          Un miembro del personal se comunicará con usted para fijar una cita para recolectar una muestra de agua y llevarla al laboratorio para análisis.
          El laboratorio le enviará los resultados de su prueba y la OHA le enviará una carta con información adicional sobre sus resultados.
        </p>

        <p >
          Los hogares con pozos que tienen niveles de nitrato superiores a 10 miligramos por litro de agua recibirán agua embotellada gratuita y/o la instalación
          de un sistema de tratamiento de agua, según los resultados de las pruebas. Nuevamente, le agradecemos por haber solicitado el análisis de su agua de pozo.
          Hacerse la prueba del pozo ayuda a proteger la salud de su familia, sus mascotas y su comunidad.
        </p>

        <p >
          Dependiendo de la cantidad de personas que soliciten asistencia, es posible que nos demoremos en comunicarnos con usted. Si no ha recibido una llamada dentro
          de cinco días hábiles, o si tiene alguna otra pregunta, llame a nuestro equipo al 541-952-9254 o envíenos un correo electrónico
          a Domestic.Wells@odhsoha.oregon.gov.
        </p>

        <p >
          Atentamente,<br />
          Oregon Health Authority<br />
          Domestic Well Safety Program - Programa de Seguridad de Pozos Domésticos<br />
          800 NE Oregon St Ste 640, Portland OR 97232 | 541-952-9254<br />https://testmywell.oregon.gov | https://pruebadepozo.oregon.gov
      
        </p>


      </span>
    </body>
  </section>
</ng-template>
</mat-dialog-content>